import { render, staticRenderFns } from "./performance-chart.vue?vue&type=template&id=59f29c52&scoped=true&"
import script from "./performance-chart.vue?vue&type=script&lang=js&"
export * from "./performance-chart.vue?vue&type=script&lang=js&"
import style0 from "./performance-chart.vue?vue&type=style&index=0&id=59f29c52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f29c52",
  null
  
)

export default component.exports